<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
      :loading="false"
  >
    <template #layoutContent>
      <Loader :isLoading="isLoading">
        <div id="" class="row">
          <div class="col-lg-8 mb-5 order-1 order-lg-0">
            <Card class="card p-5">
            <template #cardHeader>
              <div class="card-header">
                <h2 class="card-title">
                  {{ task?.title }}
                  <img v-if="task?.need_review" :title="$t('tasks.label.beReview')" class="ms-2 h-30px" src="/assets/media/icons/need_review.png" alt="need_review_icon">
                </h2>
                <div class="card-toolbar">
                  <i class="fas fa-edit fs-1 cursor-pointer" @click="openEditModal"></i>
                </div>
              </div>
            </template>
             <div class="p-10">
              <div class="d-flex justify-content-between">
                <div>
                  <h4>{{ $t("projects.project") }} :
                    <a href="#" @click.prevent="goToProject">{{task?.project?.title}}</a>
                  </h4>
                </div>
                <div>
                  <h4>{{ $t("projects.mainStep") }} :   {{task?.projectCategoryStep?.title}}</h4>
                </div>
              </div>
              <br><br>
               <Description :task="task" @load="loadTaskData"/>
               <br>
               <Checklist :title="$t('tasks.checklist') + ' (' + checkedCount + '/' + checklists?.length + ')'"/>
               <br>
               <Files/>
               <br>

              <Section :title="$t('projects.comments')" :border="true">
                <History/>
              </Section>
             </div>

             
            </Card>
          </div>
          <div class="col-lg-4 mb-5 order-0 order-lg-1">
            <Card class="card p-5">
              <Section :title="$t('tasks.users')">
                  <div class="d-flex flex-row-reverse" style="margin-top: -20px;">
                    <i class="fas fa-plus fs-1 cursor-pointer" @click="addUsersToTask"></i>
                  </div>
                  <div>
                    <div class="symbol-group symbol-hover">
                      <div v-for="user in task?.users" :key="user?.id" class="symbol symbol-35px symbol-circle" :title="user?.lastname +' '+user?.firstname">
                        <span class="symbol-label bg-primary text-inverse-primary fw-bolder">{{ user?.initials }}</span>
                      </div>
                    </div>
                  </div>
              </Section>
              <br>
              <Section :title="$t('tasks.setting')">
                <Row :title="$t('tasks.startDate')" icon="fas fa-calendar-plus">{{task?.startDate ? $dateFormatter(task?.startDate, locale, false, true) : ''}}</Row>
                <Row :title="$t('projects.table.end_at')" icon="fas fa-calendar-plus">{{task?.endDate ? $dateFormatter(task?.endDate, locale, false, true) : ''}}</Row>
                <Row :title="$t('tasks.label.status')" icon="fas fa-flag">{{task?.taskStatus?.title}}</Row>
                <Row :title="$t('tasks.label.priority')" icon="fas fa-star">{{task?.taskPriority?.title}}</Row>
                <Row :title="$t('tasks.createdBy')" icon="fas fa-user">{{task?.creator?.firstname}} {{task?.creator?.lastname}}</Row>
              </Section>
              <br>
            </Card>
            <Card class="card my-5">
              <div class="card-body">
                <h2> {{ $t("reminder.create") }} </h2>
                <p></p>
                <div class="row">
                  <div class="col-6 d-flex align-items-center">
                    <label :for="`input-task-alert-delay-value`">
                      {{ $t('reminder.advertisement') }}
                    </label>
                  </div>
                  <Input
                      :name="`task-alert-delay-value1`"
                      container-class="col-6 mb-5"
                      type="number"
                      :isRequired="true"
                      size="lg"
                      v-model="task.delay_value_alert"
                      :IsInputGroup="true"
                      is-disabled
                  >
                <span class="input-group-text w-50 border-0 py-0">
                  <Select2
                      container-class="w-100 p-0"
                      select-class="form-select form-select-transparent w-100 fs-7 lh-1 fw-bold py-0 select2-hidden-accessible"
                      :isRequired="false"
                      :multiple="false"
                      :show-search="true"
                      :name="`task-alert-delay-unit1`"
                      v-model="task.delay_unit_alert"
                      label-class="form-label"
                      is-disabled
                  >
                        <option v-for="delay in delayFrequencyEnum" :key="delay.value" :value="delay.value"> {{ delay[locale] }} </option>
                    </Select2>
                </span>
                  </Input>
                </div>
                <div class="row">
                  <div class="col-6 d-flex align-items-center">
                    <label :for="`input-task-critical-delay-value`">
                      {{ $t('reminder.inLate') }}
                    </label>
                  </div>
                  <Input
                      :name="`task-alert-delay-value2`"
                      container-class="col-6 mb-5"
                      type="number"
                      :isRequired="true"
                      size="lg"
                      v-model="task.delay_value_critical"
                      :IsInputGroup="true"
                      is-disabled
                  >
                <span class="input-group-text w-50 border-0 py-0">
                  <Select2
                      container-class="w-100 p-0"
                      select-class="form-select form-select-transparent w-100 fs-7 lh-1 fw-bold py-0 select2-hidden-accessible"
                      :isRequired="false"
                      :multiple="false"
                      :show-search="true"
                      :name="`task-critical-delay-unit2`"
                      v-model="task.delay_unit_critical"
                      label-class="form-label"
                      is-disabled
                  >
                        <option v-for="delay in delayFrequencyEnum" :key="delay.value" :value="delay.value"> {{ delay[locale] }} </option>
                    </Select2>
                </span>
                  </Input>
                </div>
              </div>
            </Card>
            <Card title="projects.historics" titleClass="fw-bolder fs-2">
              <template #cardBody>
                <div class="scroll-y" style="max-height: 518px;" v-if="task?.all_history?.length">
                  <div v-for="(historic, index) in task?.all_history" :key="index">
                    <TimeLine :id="index" :historic="historic"/>
                  </div>
                </div>
                <div class="text-center" v-else>
                  <Img filename="empty.png" alt="" class="mw-100 h-150px" />
                  <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
              </template>
            </Card>
            <div class="d-flex justify-content-end mt-5">
              <a class="btn btn-sm btn-danger" @click.prevent="deleteTask">
                <i class="fa fa-minus-circle"> </i>
                {{ $t('button.delete') }}
              </a>
            </div>
          </div>
        </div>
      </Loader>
      <UpdateTaskModal id="update_modal_task" :formEdit="formData" @load="loadTaskData"/>
      <AddTaskUsersModal id="add_task_users" :users="users" :formEdit="formData" @load="loadTaskData"/>
      <ChangeTaskMilestoneModal id="change_task_milestone" :formEdit="formData" @load="loadTaskData"/>
    </template>

  </SubLayout>
</template>
<script setup>
import {computed, onMounted, ref, watch } from "vue";
import {useStore} from "vuex";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import { useRouter, useRoute } from 'vue-router';
import Loader from "@/components/Loader";
import {useHasAbility} from "@/composables/hasAbility";
import Card from "@/components/Card.vue";
import Section from "../../components/Section.vue";
import Description from "./components/Description.vue";
import Checklist from "./components/Checklist.vue";
import History from "./components/History.vue";
import Files from "./components/Files.vue";
import Row from "./components/Row.vue";
import UpdateTaskModal from "../../components/Modals/Task/UpdateTaskModal.vue";
import AddTaskUsersModal from "../../components/Modals/Task/AddTaskUsersModal.vue";
import ChangeTaskMilestoneModal from "../../components/Modals/Task/ChangeTaskMilestoneModal.vue";
import {useSwal} from "@/composables/useSwal";
import {format} from "date-fns";
import {$dateFormatter} from "@/mixins/Helpers";
import {useLocales} from "@/composables/locales";
import Select2 from "@/components/Select2.vue";
import Input from "@/components/Input.vue";
import TimeLine from "@/Modules/Projects/components/TimelineItem.vue";
import Img from "@/components/Img.vue";

const store = useStore()
const router = useRouter()
const route = useRoute()
const {showSwal} = useSwal()
const { locale } = useLocales()

const title = ref( "projects.title")
const isLoading = ref(true)
const isDeleting = ref(false)
const task = ref({})
const { can } = useHasAbility()
const breadcrumbs = ref([
  {
    name: 'tasks.title',
    route: 'tasks-view'
  },
  
])

const formData = ref({})
const users = ref([])
const checklists = computed(() => store.getters['checklists/getChecklists'])
const checkedCount = computed(() => {
  return checklists.value.filter(item => item.checked).length;
});
const delayFrequencyEnum = computed(() => store.getters["configs/getFrequencyEnum"])

watch(() => task.value, () => {
  formData.value = {
    id:task.value?.id,
    title: task.value?.title,
    project_id: task.value?.project_id,
    project_category_step_id: task.value?.project_category_step_id,
    task_status_id: task.value?.taskStatus?.id,
    task_priority_id: task.value?.task_priority_id,
    description: task.value?.description,
    users: task.value?.users?.map(el => el?.id),
    delay_value: task.value?.delay_value,
    delay_unit: task.value?.delay_unit,
    delay_value_alert: task.value.delay_value_alert,
    delay_unit_alert: task.value.delay_unit_alert,
    delay_value_critical: task.value.delay_value_critical,
    delay_unit_critical: task.value.delay_unit_critical,
    start_date: task.value?.startDate && format(task.value?.startDate, 'dd-MM-yyyy HH:mm'),
    end_date: task.value?.endDate && format(task.value?.endDate, 'dd-MM-yyyy HH:mm'),
    task_id: task.value?.id,
    need_review: task.value?.need_review
  }
})

const goToProject = () => {
  router.push({
    name: 'projects-view',
    params:{id: route.params.project }, 
    query: {viewType: "kanban", tab: 'kt_tasks', office: route.query.office}
  })
}

function loadTaskData(){
  store.dispatch('tasks/getTask', route.params.id).then((res) => {
    task.value = res.data?.data
    if(Object.values(task.value).length > 0){
      isLoading.value = false
    }
  })
}

function loadProject() {
  store.dispatch('projects/showProject', {project_id: route.params.project})
    .then((res) => {
      users.value = [...res.data.data?.users]
      res.data.data?.managers.forEach((manager) => {
        if(!users.value.find(user => user?.id === manager?.id)) {
          users.value.push(manager)
        }
      })
      return users
    })
}

function openEditModal(){
  $('#update_modal_task').modal('toggle')
}

function addUsersToTask(){
  $('#add_task_users').modal('toggle')
}

function changeTaskMilestone(){
  $('#change_task_milestone').modal('toggle')
}

function deleteTask() {
  showSwal(
      i18n.global.t('swal.task_delete'),
      i18n.global.t('swal.task_delete_text')
  ).then( async (result) => {
    if (result.value) {
      isDeleting.value = true
      store.dispatch('tasks/deleteTask', route.params.id)
          .then((res) => {
            router?.back()
          }).finally(() => isDeleting.value = false)
    }
  })
}


onMounted(() => {
  loadTaskData()
  loadProject()
  store.dispatch('checklists/loadChecklists', route.params.id)
  store.dispatch('files/loadTaskFiles', route.params.id)
  store.dispatch('comments/loadTaskComments', route.params.id)

  store.dispatch('projectSteps/loadProjectSteps', route.params.project)
  store.dispatch('taskPriorities/loadTaskPriorities')
  store.dispatch('taskStatus/loadTaskStatus')
  store.dispatch("user/loadUsers")
  store.dispatch('configs/loadFrequencyEnum')

})
</script>

<style scoped>
.card-title{
  font-size: large;
  font-weight: bold;
}

.back{
  background-color: var(--bs-light-primary);
  border-radius: 8px;
  padding: 10px;
  width: auto;
}


.table td, .table th, .table tr {
  border-style: solid !important;
  border-width: 1px !important;
  border-color: #8a8b8b !important; /* Ajoute une bordure */

}
.border{
  border-style: solid !important;
  border-width: 1px !important;
  border-color: #8a8b8b !important; /* Ajoute une bordure */
}
</style>
